<script>
    import ReportGraphic from '../../Models/reportGraphic';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';

    function addGraphic() {
        addFormModal({
            fields: forms['reportGraphic'],
            title: "Add Graphic",
        }).then((data) => {
            ReportGraphic.createItem(data).then((graphic) => {
                notifier.success("Graphic Added");
                location.assign(`#/reportGraphic/edit/${graphic.id}`);
            });
        }).catch(e => {});
    }

    function deleteGraphic(graphic) {
        confirm(`Are you sure you want to delete ${graphic.name}?`).then(() => {

            let _graphic = new ReportGraphic(graphic._id);
            _graphic.delete().then(() => {
                notifier.success("Graphic Deleted")
            });
        }).catch(console.error)
    }

    let GraphicList = ReportGraphic.getList();
</script>

<Loader loading={!$GraphicList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Report Graphics</h1>
        <SortableTable sortFields={tables['reportGraphic']} tableData={$GraphicList}>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addGraphic}>Add Graphic</button>
                </div>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addGraphic}>Add Graphic</button>
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={graphic}>
                <a class="button is-info" href="#/reportGraphic/edit/{graphic._id}">Edit</a>
                <button class="button is-danger" on:click={() => deleteGraphic(graphic)}>Delete</button>
            </div>
        </SortableTable>
    </div>
</Loader>